'use strict';

function add(a, b) {
	return a + b;
}

function safeNumberOp(a, b, op) {
	a = Number(a);
	a = !isNaN(a) ? a : 0;
	b = Number(b);
	b = !isNaN(b) ? b : 0;
	return op(a, b);
}

function isSummaryStale(s) {
	return !s || !s.hasOwnProperty('stale') || Boolean(s.stale);
}

function addSummaries(s1, s2) {
	if (isSummaryStale(s1) || isSummaryStale(s2)) {
		return {stale: true, count: 0};
	}

	let r = Object.assign({stale: false, count: 0}, s1);
	if (!s2) {
		return r;
	}
	let count = safeNumberOp(s1.count, s2.count, add);
	if (!count) {
		return {stale: false, count: 0};
	}
	r.stale = false;
	r.count = count;
	r.total = safeNumberOp(s1.total, s2.total, add);
	r.max = safeNumberOp(s1.max, s2.max, Math.max);
	r.min = safeNumberOp(s1.min, s2.min, Math.min);
	return r;
}

export {isSummaryStale, addSummaries, safeNumberOp};

